import { render, staticRenderFns } from "./wizard-store-edit.vue?vue&type=template&id=b8e79a74&scoped=true"
import script from "./wizard-store-edit.vue?vue&type=script&lang=ts"
export * from "./wizard-store-edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e79a74",
  null
  
)

export default component.exports